import { Service } from './http-service';
import type { PaginatedResponse } from '@/entities/pagination/paginated-response';
import type { Lead, LeadsControllerFindAllData, UpdateLeadDto } from '@carvia/ros-client-types';

class LeadsApiService extends Service<Lead> {
  async getAllWithQuery(params: NonNullable<LeadsControllerFindAllData['query']>) {
    const res = await this.httpClient.get<PaginatedResponse<Lead>>(this.endpoint, { params });
    return res.data;
  }

  async update(id: string, data: UpdateLeadDto) {
    const res = await this.httpClient.patch<Lead>(`${this.endpoint}/${id}`, data);
    return res.data;
  }
}

export const leadsService = new LeadsApiService('/leads');
